const getters = {
  getFilteredImports(state) {
    return state.imports;
  },
};

export default getters;
